import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: "app-text-area",
  templateUrl: "./text-area.component.html",
  styleUrls: ["./text-area.component.scss"],
  standalone: false,
})
export class TextAreaComponent {
  @Input() placeholder: any;
  @Input() label: any;
  @Input() min = "";
  @Input() max = "";
  @Input() class = "";
  @Input() rowsCount = 0;
  @Input() isFormSubmitted: boolean = false;
  @Input() readOnly: boolean = false;
  @Input()
  set control(control: FormControl) {
    this._control = control;
    this.onControlChange$.next();
  }
  get control(): FormControl {
    return this._control;
  }
  private _control: FormControl = new FormControl();

  private onControlChange$: Subject<void> = new Subject();
  @Output()
  valueChanges = new EventEmitter<any>();
  constructor() {
    this.onControlChange$.subscribe(() => {
      this.control.valueChanges
        .pipe(takeUntil(this.onControlChange$))
        .subscribe(() => this.valueChanges.emit(this.control.value));
    });
    this.onControlChange$.next();
  }

  // ngOnInit(): void {}
  
  ngOnChanges(changes: SimpleChanges) {
    if (changes["isFormSubmitted"]) {
      this.isFormSubmitted = changes["isFormSubmitted"].currentValue;
    }
  }

  getPlaceholder(): string {
    if (
      (this.isFormSubmitted || this.control?.touched) &&
      this.control?.errors
    ) {
      if (this.control.errors["required"]) {
        return `Please enter ${this.label}`;
      }
      if (this.control.errors["minlength"]) {
        return `Min length: ${this.control.errors["minlength"].requiredLength}`;
      }
      if (this.control.errors["pattern"]) {
        return `Please enter a valid ${this.label}`;
      }
      if (this.control.errors["min"]) {
        return `Value must be >= ${this.control.errors["min"].min}`;
      }
    }
    return this.placeholder; // default placeholder when no error
  }
}
